import React from 'react';
import Tabs from 'antd/lib/tabs';
import { HelpTab } from './components/HelpTab';

import './HelpPage.less';

export const HelpPage = (props) => {
  const { theme } = props;
  const { TabPane } = Tabs;
  window.document.title = `Help`;

  return (
    <div id="help-page">
      <div className="help-page-header">
        <div className="help-page-title">Help</div>
        <Tabs className={`app-tabs-${theme}`} defaultActiveKey="1">
          <TabPane tab="Technical" key="1">
            <HelpTab content="technical" theme={theme} />
          </TabPane>
          <TabPane tab="Parity Agreement" key="2">
            <HelpTab content="agreement" theme={theme} />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};
